<template>
    <div :class="[className]">
      <span v-if="hasActiveDiscount" :class="['discounted']">
          {{
            showPricesWithTax
            ? prices?.current_formatted_price_with_tax
            : prices?.current_formatted_price
          }}
      </span>
      <span :class="[{ previous: hasActiveDiscount }]">
          {{
            hasActiveDiscount
            ? showPricesWithTax
              ? prices?.previous_formatted_price_with_tax
              : prices?.previous_formatted_price
            : showPricesWithTax
              ? prices?.current_formatted_price_with_tax
              : prices?.current_formatted_price
          }}
      </span>
    </div>
</template>

<script>
export default {
  name: "ProductPrice",

  props: {
    prices: Object,
    className: String,
  },

  computed: {
    hasActiveDiscount() {
      return this.prices?.is_active_discount || false
    },
    showPricesWithTax() {
      return true;
      // return this.$store.state.showPricesWithTax;
    },
  },

  data() {
    return {
      show_prices_with_tax: true,
      discount: true,
    };
  },
};
</script>
